<template>
  <div>
    <table class="table">
      <thead>
        <tr>
          <th>Transporter</th>
          <th>Average Duration</th>
          <th>%Hit Traget<br>(No. of Rit)</th>
          <th>%Miss Traget<br>(No. of Rit)</th>
          <!-- <th>1 Day</th>
          <th>2 Days</th>
          <th>3-4 Days</th>
          <th>5 Days</th> -->
          <th v-for="(arrChild , index) in choosenArray">{{translateString(arrChild, index, choosenArray.length)}}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="dat in ((showAll) ? data : data.slice(0, 4))">
          <td style="text-decoration: underline;">{{ dat.ekspedisi ? dat.ekspedisi : 'Unknown' }}</td>
          <td>{{ dat.avg }} Day{{(dat.avg > 1) ? 's' : ''}}</td>
          <td>{{ Math.round(dat.hit_target / dat.total * 1000) / 10 }}% ({{ numberWithCommas(dat.hit_target == '-' ? 0 : dat.hit_target) }})</td>
          <td>{{ Math.round(dat.miss_target / dat.total * 1000) / 10 }}% ({{ numberWithCommas(dat.miss_target == '-' ? 0 : dat.miss_target) }})</td>
          <!-- <td>{{ Math.round(dat.day_1 / dat.total * 1000) / 10 }}%</td>
          <td>{{ Math.round(dat.day_2 / dat.total * 1000) / 10 }}%</td>
          <td>{{ Math.round(dat.day_3_4 / dat.total * 1000) / 10 }}%</td>
          <td>{{ Math.round(dat.day_5 / dat.total * 1000) / 10 }}%</td> -->
          <td v-for="arrChild in choosenArray">{{ Math.round(dat[arrChild] / dat.total * 1000) / 10 }}%</td>
        </tr>
        <tr v-if="showAllButton">
          <td v-if="!showAll" colspan="9" class="moreButton" @click="showAll = true">Lihat Semua</td>
          <td v-else colspan="9" class="moreButton" @click="showAll = false">Sembunyikan</td>
        </tr>
      </tbody>
    </table>
    <!-- {{type}} -->
  </div>
</template>

<script>
  export default {
    data () {
      return {
        showAllButton : false,
        showAll : true,
        listMDVar : ['day_1_4' , 'day_5_6' , 'day_7_9' , 'day_10'],
        listDVar : ['day_1' , 'day_2' , 'day_3_4' , 'day_5'],
        choosenArray : null
      }
    },
    props:['filter','period', 'data' , 'type'],
    watch : {
      type : function () {
        this.choosenArray = this.type == 'MD' ? this.listMDVar : this.listDVar
      }
    },
    mounted () {
      this.choosenArray = this.type == 'MD' ? this.listMDVar : this.listDVar
    },
    methods : {
      translateString(str , index , length) {
        let strDate = ''

        let newStr = str.split('_')
        // console.log(index , length - 1)

        if(index == length - 1)
          strDate = '> '

        
        
        if(newStr.length > 2) {
          strDate += `${newStr[1]} - ${newStr[2]} Days`
        }
        else {
          strDate +=`${newStr[1]} Day${parseInt(newStr[1]) > 1 ? 's' : ''}`
        }

        return strDate
      }
    }
  }
</script>

<style scoped>
  table tr th, table tr td {
    text-align: center;
    vertical-align: middle;
  }

  table tr th {
    border-bottom: 1px solid #F75047;
  }

</style>